export default __webpack_public_path__ + "static/mattias-gardell-6010c0b03aea2376a478db50a98aad56.png";